import axios from "axios";
import authHeader from "./auth-header";

const API_URL = "https://api.savvywholesaletravel.com/";

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "auth/login", {
        username,
        password
      })
      .then(response => {
        if (response.data.access_token) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password) {
    return axios.post(API_URL + "user", {
      username: email,
      password,
      roleId: 3
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  updateProfile(firstName, email, lastName) {
    return axios.post(API_URL + "user/update-profile", {
      subscriber: {
        firstName,
        lastName
      },
      username: email
    }, { headers: authHeader() })
  }

  updatePassword(password, email) {
    return axios.post(API_URL + "user/change-password", {
      newPassword: password,
      userName: email
    }, { headers: authHeader() })
  }

  validateToken(token) {
    return axios.post(API_URL + "auth/validate-token", {
      token: token
    })
  }

  forgotPassword(email) {
    return axios.post(API_URL + "auth/forgot-password", {
      email: email
    })
  }

  resetPassword(token, newPassword) {
    return axios.post(API_URL + "auth/reset-password", {
      token: token,
      password: newPassword
    });
  }
}

export default new AuthService();
